<template>
    <div>
        <app-bar :title="content.name"/>

        <v-layout>
            <v-progress-linear
                v-if="overlay"
                absolute
                indeterminate
            ></v-progress-linear>

            <div class="pt-8 pb-12 px-8">
                <div class="pb-10">
                    <v-btn
                        v-if="permitted('admin_club_management')"
                        @click="edit"
                        class="sm mr-5"
                        color="primary"
                    >{{ t('general_action_edit') }}
                    </v-btn>
                    <v-btn
                        v-if="permitted('admin_club_management')"
                        class="sm mr-5"
                        color="primary"
                        outlined
                        @click.prevent="suspend(content)"
                    >
                        {{ content.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                    </v-btn>
                    <confirm-modal
                        v-if="permitted('admin_club_management')"
                        :title="t('general_title_confirm_action')"
                        @agree="del(content)"
                    >
                        <template #default="{ on, attrs }">
                            <v-btn
                                class="sm"
                                color="orange"
                                outlined
                                v-on="on"
                                v-bind="attrs"
                            >{{ t('general_action_delete') }}</v-btn>
                        </template>
                    </confirm-modal>
                </div>
                <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                    <img
                        v-if="content.photoUrl"
                        :src="content.photoUrl"
                        width="150"
                    />
                    <div class="form-subtitle">{{ t('club_content_label_description') }}:</div>
                    <div class="form-subtitle-description" v-html="content.description"></div>
                    <div v-if="content.videoUrl" class="form-subtitle">{{ t('club_content_label_video_url') }}:</div>
                    <div v-if="content.videoUrl" class="form-subtitle-description">{{ content.videoUrl }}</div>
                </div>
                <div class="float-left" style="max-width: calc(100% - 434px)">
                    <card-unit :items="items()">
                        <template #title>{{ t('club_content_label_id') }}: {{ content.id }}</template>
                    </card-unit>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import { useStore } from '@/store'
    import { useRouter } from '@/composition-api'
    import { useEnums } from '@/core/defaults'
    import { ClubContent } from '@/core/models/club-content'
    import ConfirmModal from '@/components/ConfirmModal.vue'
    import CardUnit from '@/components/CardUnit.vue'

    export default defineComponent({
        components: {
            ConfirmModal,
            CardUnit
        },

        setup(props) {
            const store = useStore()
            const router = useRouter()
            const i18n = useI18n()
            const enums = useEnums()
            const id = router.currentRoute.params['id']

            const state = reactive({
                overlay: true,
            })

            const capture = () => {
                store.dispatch('clubContent/get', { id: id, payload: {} }).then(() => {
                    state.overlay = false
                })
            }

            const contentModel = computed(() => <ClubContent>store.getters['clubContent/get'])

            const suspend = (item: ClubContent) => {
                state.overlay = true
                store.dispatch('clubContent/update', {
                    id: item.id,
                    payload: { enabled: ! item.enabled }
                }).then(() => {
                    store.dispatch('notify', { color: 'success', message: i18n.t('general_notice_data_updated') })
                    capture()
                })
            }

            const edit = () => router.push({ name: 'club-contents.show', params: { id: <any>contentModel.value.id } })

            const del = (item: ClubContent) => {
                state.overlay = true
                store.dispatch('clubContent/delete', { id: item.id }).then(() => {
                    router.push({ name: 'club-contents' })
                })
            }

            const items = () => {
                return [
                    { text: i18n.t('club_content_label_type'), value: enums.clubContentTypeTitle(contentModel.value.type) },
                    { text: i18n.t('general_label_creation_date'), value: contentModel.value.createdAt.format('DD/MM/YYYY') },
                    { text: i18n.t('general_action_published'), value: contentModel.value.enabled ? i18n.t('general_text_yes') : i18n.t('general_text_no') },
                ]
            }

            onMounted(() => {
                capture()
            })

            return {
                capture,
                items,
                content: contentModel.value,
                edit,
                del,
                suspend,
                ...useI18n(),
                ...useEnums(),
                ...toRefs(state)
            }
        }
    })
</script>
